import { TranslateService } from '@ngx-translate/core';

export interface FaultDetails {
    message: string;
    completeMessage: string;
}

export enum Importance {
    high = 0,
    medium = 1,
    low = 2,
    ignorable = 3,
}

export type CustomExceptionConstructor<F extends FaultDetails, E extends CustomException> = new (
    fault: F,
    translateService: TranslateService,
) => E;

export class CustomException extends Error {
    // data members
    title: string;
    importance: Importance = Importance.low;

    // constructor

    constructor(faultDetails: FaultDetails, protected translateService: TranslateService) {
        super(faultDetails.message);

        Object.setPrototypeOf(this, CustomException.prototype);
    }
}

export class ExceptionFactory {
    // data memebrs

    private static store: Record<string, CustomExceptionConstructor<FaultDetails, CustomException>> = {};

    // public functions

    static create(
        typeName: string,
        faultDetails: FaultDetails,
        translateService: TranslateService,
    ): Error | CustomException {
        const exceptionName = typeName.replace('Fault', 'Exception');
        const clazz = ExceptionFactory.store[exceptionName];

        if (clazz) {
            return new clazz(faultDetails, translateService);
        }

        return new Error(faultDetails.completeMessage);
    }

    static register<F extends FaultDetails, E extends CustomException>(
        clazz: CustomExceptionConstructor<F, E>,
        typeName: string,
    ) {
        ExceptionFactory.store[typeName] = clazz;
    }
}
